import { configureStore } from "@reduxjs/toolkit";
import {
  createMigrate,
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import allReducers from ".";
import { titanApi } from "../services/API/titanApi";
import { apiErrorLogger } from "./middleware/apiErrorLogger";
import { charsetErrorMiddleware } from "./charsetErrorMiddleware";

// https://github.com/rt2zz/redux-persist/blob/master/docs/migrations.md
const migrations = {
  2: (state) => {
    // migration to keep only bemessungenMikropfaehle
    return {
      bemessungenMikropfaehle: state.bemessungenMikropfaehle,
    };
  },
  3: (state) => {
    return {
      bemessungenMikropfaehle: state.bemessungenMikropfaehle,
    };
  },
  8: (state) => {
    return null;
  },
  23: (state) => {
    return {
      ...state,
      datatables: {
        currentTable: {
          eurocode: "Bohrkronen",
          aashto: "Carrying elements",
          products: "Products",
        },
        addNewState: false,
      },
    };
  },
  24: (state) => {
    return {
      ...state,
      aashto: null,
    };
  },
  25: (state) => {
    return {
      ...state,
      epd: {},
    };
  },
};

const persistConfig = {
  debug: false,
  key: "root",
  version: 30,
  migrate: createMigrate(migrations, { debug: false }),
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [titanApi.reducerPath],
};

const persistedReducer = persistReducer(persistConfig, allReducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(titanApi.middleware, apiErrorLogger, charsetErrorMiddleware),
});
